import { classes } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useSchedule = (slug, params) => {
	return useQuery({
		queryKey: ['schedule', slug, params],
		queryFn: () => classes.getSchedule(slug, params),
		select: data => data?.data,
		enabled: !!params?.date_from && !!params?.date_to
	});
};